// @flow
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import { ThemeProvider } from '@material-ui/styles';
import { theme } from './theme';

// Routes
import { routes } from './routes';
import NoMatch from './views/NoMatch';

// Components
import Header from './components/header';
import Footer from './components/footer';

// HOC
import WithLoading from './components/hoc/WithLoading';

// Data
import { defaultSeoConfig } from './components/helpers/defaultSeoConfig';

// Context
import { TrainsProvider } from './TrainsContext';
import UserNoticePopup from './components/ui/UserNoticePopup';

const App = () => {
  const [domLoading, setLoading] = useState(true);
  const [completed, setCompleted] = React.useState(0);

  useEffect(() => {
    function progress() {
      setCompleted(oldCompleted => {
        if (oldCompleted >= 100) {
          setLoading(false);
        }
        const diff = Math.random() + 90;
        return Math.min(oldCompleted + diff, 100);
      });
    }

    const timer = setInterval(progress, 500);
    return () => {
      clearInterval(timer);
    };
  }, []);

  return (
    <Router>
      <ThemeProvider theme={theme}>
        <Helmet>
          <title>{defaultSeoConfig.title}</title>
          <meta name="description" content={defaultSeoConfig.description} />
          {/* Open Graph */}
          <meta property="og:type" content={defaultSeoConfig.openGraph.type} />
          <meta
            property="og:title"
            content={defaultSeoConfig.openGraph.title}
          />
          <meta
            property="og:description"
            content={defaultSeoConfig.openGraph.description}
          />
          <meta
            property="og:image"
            content={defaultSeoConfig.openGraph.images[0].url}
          />
          {/* Twitter */}
          <meta
            name="twitter:card"
            content={defaultSeoConfig.twitter.cardType}
          />
        </Helmet>
        <div className="App">
          <Header />
          <WithLoading isLoading={domLoading} completed={completed}>
            <div className="App__Body">
              <TrainsProvider>
                <Switch>
                  {routes.map((route, i) => (
                    <Route key={i} {...route} />
                  ))}
                  <Route component={NoMatch} />
                </Switch>
              </TrainsProvider>
            </div>

            <UserNoticePopup />
            <Footer />
          </WithLoading>
        </div>
      </ThemeProvider>
    </Router>
  );
};

export default App;
